"use strict";
// CA is the national scope already used by Minimum Service reporting.
// Only the 13 provinces/territories are valid geographic assignments.
const NATIONAL_REGION_CODE = 'CA';
const NATIONAL_REGION_NAME = 'NWAC National';
const PROVINCE_TERRITORY_CODES = Object.freeze([
  'AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT',
]);
const normalize = value => String(value || '').trim().toUpperCase();
const isGeographicRegion = code => PROVINCE_TERRITORY_CODES.includes(normalize(code));
const isFinanceRegion = code => isGeographicRegion(code) || normalize(code) === NATIONAL_REGION_CODE;
const hasInvalidFinanceDraftRegions = payload => (payload?.pots || []).some(pot =>
  pot?.regions != null && (!Array.isArray(pot.regions) || pot.regions.some(code => !isFinanceRegion(code)))
);
module.exports = { hasInvalidFinanceDraftRegions, NATIONAL_REGION_CODE, NATIONAL_REGION_NAME, PROVINCE_TERRITORY_CODES, isGeographicRegion, isFinanceRegion };
